import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  breakpoints: { BreakpointNames },
  colors: { ui },
} = constants;

export const rootCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  ...typographyStyles.fontFamily.circular,

  [mediaQuery.upTo("1090px")]: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
};

export const rootViewOrCreateModeCss: CSSObject = {
  ...rootCss,
  padding: "12px 16px",
  border: `1px solid ${ui.neutral[100]}`,

  [mediaQuery.upTo("1090px")]: {
    display: "flex",
    flexDirection: "column",
  },

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    display: "flex",
    flexDirection: "column",
  },
};

export const headingRootCss: CSSObject = {
  [mediaQuery.upTo("1090px")]: {
    justifyContent: "flex-start",
    width: "100%",
    marginBottom: "8px",
  },
};

export const titleCss = {
  ...typographyStyles.heading4Obj,
  fontWeight: 700,
  marginBlock: 0,
};

export const subtitleCss = {
  ...typographyStyles.textMObj,
};

export const inputGroupCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  gap: "8px",

  "& > div": {
    padding: 0,
    flexBasis: "150px",
    flexShrink: 0,
  },

  [mediaQuery.upTo("1090px")]: {
    width: "100%",
  },

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "28px",

    "& > div:first-of-type": {
      marginBottom: "8px",
    },

    "& > div": {
      flexBasis: "auto",
      marginBottom: "0px",
    },
  },
};
